import React from 'react';
import { Box } from '@mui/material';

/**
 * BoxShadow - A wrapper component that applies Material-UI boxShadow level 1 to its children
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child elements to be wrapped
 * @param {Object} [props.sx] - Additional sx styles to merge with the boxShadow
 * @returns {JSX.Element} MUI Box with boxShadow:1 containing children
 */
const BoxShadow = ({ children, sx = {}, ...rest }) => {
  return (
    <Box 
      sx={{ 
        boxShadow: 3,
        p: 2,
        borderRadius: 2,
        width: '100%',
        ...sx
      }} 
      {...rest}
    >
      {children}
    </Box>
  );
};

export default BoxShadow;
